<div
  class="after2017_container "
  [style.grid-template-columns]="after2017TemplateHeader"
  [ngClass]="this.screenVisible === 'allIssues' ? 'showAllHeader' : ''"
>
  @for (col of displayColumns; track $index) {
    @if (col.multiline.length > 0) {
      <div class="cell multiline-cell">
        @for (line of col.multiline; track $index) {
          <h2>{{ line }}</h2>
        }
      </div>
    } @else if (col.children.length > 0) {
      <div class="group-cell">
        <h2>{{ col.topLabel }}</h2>

        <div
          class="sub-grid"
          [style.grid-template-columns]="'repeat(' + col.children.length + ', 1fr)'"
        >
          @for (child of col.children; track $index) {
            <h2 class="sub-cell">{{ child.subLabel }}</h2>
          }
        </div>
      </div>
    } @else {
      <h2 class="cell">{{ col.subLabel }}</h2>
    }
  }
</div>
